import React, { FunctionComponent } from 'react';
import { Table } from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';
import './styles.css';

interface ITable {
  data: any;
  children: React.ReactNode;
  count: number;
  rowClick?: (data: any, event?: any) => void;
  rowClassName?: any;
  height?: number;
  headerHeight?: number;
  rowHeight?: number;
}

const List: FunctionComponent<ITable> = ({
  children,
  data,
  rowClick,
  rowClassName,
  height,
  headerHeight,
  rowHeight,
}) => {
  let rowClassNameSet: any = rowClick ? `tablePointer` : '';
  if (rowClassName !== undefined) {
    rowClassNameSet = rowClassName;
  }

  let autoHeight = true;
  let customHeight = 200;
  if (height !== undefined) {
    autoHeight = false;
    customHeight = height;
  }

  return (
    //@ts-ignore
    <Table
      autoHeight={autoHeight}
      height={customHeight}
      headerHeight={headerHeight === undefined ? 56 : headerHeight}
      rowHeight={rowHeight === undefined ? 56 : rowHeight}
      data={data}
      onRowClick={rowClick}
      rowClassName={rowClassNameSet}
    >
      {children}
    </Table>
  );
};

export default List;
